<app-drawer-component [drawerClass]="'flagFilter'" [drawerOpen]="flagDrawerOpen" [list]="list" [drawerTitle]="'Pick a flag'" (onClicked)="onDrawerItemClicked($event)" (drawerState)="onUpdateDrawerState($event)"></app-drawer-component>
